function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredefinedLookups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 4966",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6648",
    d: "M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0zm.625 14.325V15a.625.625 0 0 1-1.25 0v-.677a3.324 3.324 0 0 1-1.665-.755.625.625 0 0 1 .83-.935 2.218 2.218 0 0 0 1.46.493c1.016 0 1.875-.573 1.875-1.25s-.859-1.25-1.875-1.25c-1.723 0-3.125-1.121-3.125-2.5a2.719 2.719 0 0 1 2.5-2.45V5a.625.625 0 0 1 1.25 0v.677a3.324 3.324 0 0 1 1.665.755.625.625 0 0 1-.83.935A2.218 2.218 0 0 0 10 6.875c-1.016 0-1.875.572-1.875 1.25s.859 1.25 1.875 1.25c1.724 0 3.125 1.121 3.125 2.5a2.719 2.719 0 0 1-2.5 2.45z",
    style: {
      fill: "#aeaeae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredefinedLookups);
export default __webpack_public_path__ + "static/media/predefined-lookups.f69f7b4965f57b414c1eed84f47558c5.svg";
export { ForwardRef as ReactComponent };